module.exports = __webpack_public_path__ + "img/c0a3fcd.png";